import React from 'react';
import { observer, inject } from 'mobx-react';
import LineItemPickerPanel from 'components/LineItemPicker/LineItemPickerPanel';

// "Add labor" / "Add material" on an estimate (components/LineItemPicker).
// Callers pass `type`: 'Service' for labor, 'Products (Non-inventory)' for materials.
const AddProductForEstimateModal = inject('quoteStore')(observer(({ quoteStore, isOpen, onClose, workDetail, type, itemType }) => {
  const kind = type === 'Service' ? 'labour' : 'material';
  return (
    <LineItemPickerPanel
      formType="Quote"
      noun="estimate"
      record={workDetail || quoteStore.quote.object}
      type={type}
      itemType={itemType}
      isOpen={isOpen}
      onClose={onClose}
      blankBusy={Boolean(quoteStore.isLoadingBlankLineItem)}
      onAddBlank={() => quoteStore.addBlankLineItemForProduct(kind, (workDetail || quoteStore.quote.object).attributes.id)}
    />
  );
}));

export default AddProductForEstimateModal;
